import { createTheme } from "@mui/material/styles";
import { afyaTheme } from "./styles/afyaTheme";

// Adaptando o tema do Material UI de acordo com o afyaTheme
const theme = createTheme({
  palette: {
    primary: {
      main: afyaTheme.type["active-menu"], // CE0058 - Cor principal da Afya
      dark: "#a80047", 
      light: "#dd4b85",
      contrastText: "#ffffff",
    },
    secondary: {
      main: afyaTheme.type.link, // 212322
      dark: "#000000",
      light: "#3c3e3d",
      contrastText: "#ffffff",
    },
    background: {
      default: afyaTheme.surface.body, // F3F7F9
      paper: afyaTheme.surface.box, // FFFFFF
    },
    text: {
      primary: afyaTheme.type.body, // 485668
      secondary: afyaTheme.type.placeholder, // 979CA1
    },
    error: {
      main: afyaTheme.feedback.error, // DA3333
    },
    warning: {
      main: afyaTheme.feedback.alert, // F7B500
    },
    success: {
      main: afyaTheme.feedback.success, // 2DAC3A
    },
  },
  typography: {
    fontFamily: afyaTheme.headline1.fontFamily,
    h1: {
      ...afyaTheme.headline1,
    },
    h2: {
      ...afyaTheme.headline2,
    },
    h3: {
      ...afyaTheme.headline3,
    },
    h4: {
      ...afyaTheme.headline4,
    },
    body1: {
      ...afyaTheme.body,
    },
    body2: {
      ...afyaTheme.small,
    },
    button: {
      fontWeight: 600,
      textTransform: "uppercase",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: afyaTheme.type["active-menu"],
          color: afyaTheme.type.button,
          "&:hover": {
            backgroundColor: afyaTheme.surface["button-hover"],
          },
        },
        text: {
          color: afyaTheme.type["active-menu"],
        },
        outlined: {
          borderColor: afyaTheme.type["active-menu"],
          color: afyaTheme.type["active-menu"],
        },
        root: {
          borderRadius: afyaTheme.border.radius.button,
          padding: `${afyaTheme.spacing.positive.p} ${afyaTheme.spacing.positive.l}`,
        }
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: afyaTheme.border.radius.box,
          boxShadow: afyaTheme.shadow.box,
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          "&.Mui-active": {
            color: afyaTheme.type["active-menu"],
          },
          "&.Mui-completed": {
            color: afyaTheme.type["active-menu"],
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: afyaTheme.border.input,
          "&.Mui-checked": {
            color: afyaTheme.type["active-menu"],
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: afyaTheme.border.input,
          "&.Mui-checked": {
            color: afyaTheme.type["active-menu"],
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: afyaTheme.border.radius.input,
            "& fieldset": {
              borderColor: afyaTheme.border.input,
            },
            "&:hover fieldset": {
              borderColor: afyaTheme.border["input-focus"],
            },
            "&.Mui-focused fieldset": {
              borderColor: afyaTheme.type["active-menu"],
            },
          },
        },
      },
    },
  },
});

export default theme;
